import Details from '@/components/Details/Details';
import TimeZoneSelector from '@/components/TimeZoneSelect/time-zone-select.component';
import ScheduleInput from '@/components/schedule/schedule-input.component';
import IBookingRules from '@/types/IBookingRules';
import IServerRepeatingAvailability from '@/types/IServerRepeatingAvailability';
import {
	Alert,
	AlertDescription,
	AlertIcon,
	Box,
	Button,
	Flex,
	FormControl,
	FormLabel,
	Popover,
	PopoverBody,
	PopoverCloseButton,
	PopoverContent,
	PopoverTrigger,
	Switch,
} from '@chakra-ui/react';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import useSectionSchedule from './section-schedule.controller';

export interface ISectionScheduleProps {
	bookingRules: IBookingRules;
	onChange: (value: { repeatingAvailability: IServerRepeatingAvailability | null }) => void;
}

export default function SectionSchedule(props: ISectionScheduleProps) {
	const {
		t,
		isLoading,
		weekly,
		timeZone,
		isEmpty,
		handleWeeklyChange,
		handleTimeZoneChange,
		handleCreateCustomScheduleClick,
		handleAlwaysOpenClick,
	} = useSectionSchedule(props);

	return (
		<Details title={t('Working hours')}>
			<Flex justifyContent="end" mb={4}>
				<Popover placement="bottom-end">
					<PopoverTrigger>
						<Button size="xs" rightIcon={<BiDotsVerticalRounded />}>
							{t('Menu')}
						</Button>
					</PopoverTrigger>
					<PopoverContent>
						<PopoverCloseButton />
						<PopoverBody>
							<FormControl mt={4}>
								<Switch
									size="sm"
									isChecked={props.bookingRules.repeatingAvailability === null}
									onChange={(e) => {
										e.target.checked ? handleAlwaysOpenClick() : handleCreateCustomScheduleClick();
									}}
								>
									{t('Available 24/7')}
								</Switch>
							</FormControl>

							<FormControl mt={4}>
								<FormLabel>{t('TimeZone')}</FormLabel>
								<TimeZoneSelector size="sm" value={timeZone} onChange={handleTimeZoneChange} />
							</FormControl>
						</PopoverBody>
					</PopoverContent>
				</Popover>
			</Flex>

			{weekly ? (
				<ScheduleInput isLoading={isLoading} value={weekly} onChange={handleWeeklyChange} />
			) : (
				<Box>
					<Button
						onClick={handleCreateCustomScheduleClick}
						mt={4}
						variant="solid"
						w="full"
						size="sm"
						isLoading={isLoading}
						colorScheme="primary"
					>
						{t('Create custom schedule')}
					</Button>
				</Box>
			)}

			<Alert mt={4} size="sm" status="error" display={isEmpty ? 'flex' : 'none'}>
				<AlertIcon />
				<AlertDescription>{t('To receive bookings, please add at least one time slot.')}</AlertDescription>
			</Alert>
		</Details>
	);
}
